import { Controller } from "@hotwired/stimulus"

// 調査手法ラジオの選択に応じて、data-show-for / data-hide-for を持つブロックを表示/非表示する。
// data-show-for: 指定した手法のときだけ表示 / data-hide-for: 指定した手法のときだけ非表示
export default class extends Controller {
  static targets = ["radio", "field"]

  connect() {
    this.update()
  }

  update() {
    const method = this.selectedMethod()
    this.fieldTargets.forEach((el) => {
      const showFor = (el.dataset.showFor || "").split(" ").filter(Boolean)
      const hideFor = (el.dataset.hideFor || "").split(" ").filter(Boolean)
      let visible = true
      if (showFor.length > 0) visible = showFor.includes(method)
      if (hideFor.length > 0) visible = !hideFor.includes(method)
      el.classList.toggle("hidden", !visible)
    })
  }

  selectedMethod() {
    // 通常のラジオ ( type=radio ) は checked をみる。
    // 編集画面などで hidden_field を radio target として登録している場合は、 その value をそのまま採用する。
    const checkedRadio = this.radioTargets.find((el) => el.type === "radio" && el.checked)
    if (checkedRadio) return checkedRadio.value
    const hidden = this.radioTargets.find((el) => el.type === "hidden")
    return hidden ? hidden.value : ""
  }
}
